<template>
  <div class="refInfo">
    <personalInfo v-if="current == 2"></personalInfo>
    <companyInfo v-if="current == 1"></companyInfo>
    <div style="text-align: center; padding: 100px 0 0">
      <el-button size="small" class="changeForm" @click="editorInfo">编辑</el-button>
    </div>
  </div>
</template>

<script>
import personalInfo from "./personalInfo";
import companyInfo from "./companyInfo";
export default {
  components: {
    companyInfo,
    personalInfo,
  },
  mounted() {
    let obj = JSON.parse(sessionStorage.getItem("backstageUser"));
    if (obj.type == 1) {
      this.current = 1;
    } else {
      this.current = 2;
    }
  },
  data() {
    return {
      current: 1,
    };
  },
  methods: {
    editorInfo() {
      if (this.current == 1) {
        this.$router.push({
          path: "/servicecenter/regInfo/company",
        });
      }
      if (this.current == 2) {
        this.$router.push({
          path: "/servicecenter/regInfo/personal",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.refInfo {
  background-color: #fff;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
}
.changeForm {
  width: 150px;
  height: 40px;
  background: #14d393;
  border-radius: 6px;
  border: none;
  color: #fff;
  font-style: 16px;
}
</style>


// WEBPACK FOOTER //
// src/views/servicecenter/regInfo/index.vue